<div class="page-title-container d-flex">
  @if (baseService!=undefined && baseService._currentTitle!=undefined) {
    <div class="page-title flex-grow-1">
      {{baseService._currentTitle}}
    </div>
  }
</div>
@if (!currentData.navigated) {
  <div class="_arc-top-section">
    <div class="grid-search-wrapper">
      <div class="_complex-search">
        <app-complex-search [config]="currentData.complexSearch"
          (onFilterChange)="filterClick($event);">
        </app-complex-search>
      </div>
    </div>
  </div>
}

<ng-container>
  <!-- Banner -->
  @if (currentData.bannerData!=undefined && currentData.bannerData['uhId']!=undefined) {
    <div>
      <!-- <app-resource-banner [bannerJson]="currentData.bannerJson"></app-resource-banner> -->
      <div class="_arc-banner"><span class="mr-2">{{currentData.bannerData['patient_name']}}</span><span
    class="mr-2">{{currentData.bannerData['uhId']}}</span><span
  class="mr-2">{{currentData.bannerData['patient_age']}}</span><span
class="mr-2">{{currentData.bannerData['patient_gender']}}</span><span
class="mr-2">{{currentData.bannerData['patient_telecom']}}</span></div>
</div>
}

<!-- for buttons -->
@if (currentData.bannerData!=undefined && currentData.bannerData['uhId']!=undefined) {
  <div class="_arc-button-container"
    >
    @for (btn of currentData.json.tabs; track btn) {
      <button (click)="setViewer(btn)" class="_arc-buttons"
        [ngClass]="btn.key==currentData.currentBtn?'activeBtn':''">
        <i class="fa fa-folder-open" aria-hidden="true"></i>
        {{btn.label}}
      </button>
    }
  </div>
}


<div class="_arc-top-left-section">
  <!--Filter Section-->
  @if (currentData.clonedList!=undefined && currentData.clonedList.length!=undefined && currentData.clonedList.length>0) {
    <div class="_filter-button-wrapper mb-1">
      @if (this.currentData['filterBlock'] != undefined) {
        <div class="_filter-button" (click)="displayFilter()">
          <!-- <span class="filter-text">Filter</span> -->
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      }
    </div>
    @if (currentData['filterBlock']!=undefined && currentData['filterBlock'].default_open!=undefined) {
      <div class="col-12 pl-4 pr-4"
        [hidden]="!(currentData['filterBlock'].default_open)"
        (clickOutside)="displayFilter()">
        <div class="row grid_filter">
          <div class="filter-body">
            <!-- <span class="filter-arrow"><i class="fa fa-caret-up" aria-hidden="true"></i></span> -->
            <span class="close-filter-btn"
              (click)="displayFilter()">
              <i class="fa fa-times-circle"
              aria-hidden="true"></i></span>
              @if (this.currentData['filterBlock']) {
                <div class="filter-form"
                  >
                  <kx-filter [config]="{}"
                    [fields]="this.currentData['filterBlock']"
                    (getFilter)="doSearch($event);displayFilter()"
                    (resetFilter)="resetFilter($event);displayFilter()">
                  </kx-filter>
                </div>
              }
            </div>
          </div>
        </div>
      }
    }
    <!--Filter Section-->
  </div>

  <!-- tabs -->
  @if (currentData.list!=undefined && currentData.list.length!=undefined && currentData.list.length>0) {
    <div class="app-common-viewer-container"
      >
      <div>
        <!-- <div class="_arc-doc-viewer-top-section"> -->
        <!-- <div class="_arc-top-right-section">
        <select class="form-control">
          <option>Select</option>
        </select>
      </div> -->
      <!-- <div class="_arc-top-right-section"
      *ngIf="currentData['currentBtn']!=undefined && currentData['currentBtn']=='billing_journey'">
      <select (change)="setDropdownView($event);" class="form-control"
        [(ngModel)]="currentData.dropdownDataVal">
        <option *ngFor="let option of currentData.dropdownData; let i = index;"
          [value]="i">
          {{option.print_type}}
        </option>
      </select>
    </div> -->
  <!-- </div> -->
  <!-- content -->
  <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer">
    <div class="cursor-pointer m-0 p-0 max-width-card" id="scrollTestLab" scroll-directive>
      @if (currentData.list!=undefined && currentData.list.length > 0) {
        <div>
          @for (entity of currentData.list; track entity; let i = $index) {
            <div #activeTab class="_wf-historytab doc-view-list row"
              [ngClass]="!this.utilService.isMobile() ?{'doc-active-tab': i==0?true:false} : ''"
              (click)="!this.utilService.isMobile() ? [setView(entity.print_details,0), activeTab.classList.toggle('doc-active-tab')] : mobileEventCall(entity)"
              [id]="'labtestList' +i">
              @for (field of currentData.fields; track field) {
                @if ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') {
                  <div
                    [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-historytabheading' : (field.class_name ? field.class_name : '_wf-historytableft')">
                    @if (field.show_heading == undefined || field.show_heading) {
                      <span class="wf0historycategory"
                        >
                      {{field.heading|translate|async}}</span>
                    }
                    @if ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') {
                      <div [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-cf-heading' : '_wf-historybolddata'"
                        >
                        {{entity
                        | mapvalue : field}}
                      </div>
                    }
                  </div>
                }
                @if (field.type == 'datetime') {
                  <div [ngClass]="field.class_name ? field.class_name : '_wf-historytableft'"
                    >
                    <div class="wf0historycategory">
                    {{field.heading|translate|async}}</div>
                    <div class="_wf-historybolddata">{{entity |
                      mapvalue :
                    field | dateTimeFormat}}</div>
                  </div>
                }
                @if (field.type == 'date') {
                  <div [ngClass]="field.class_name ? field.class_name : '_wf-historytableft'"
                    >
                    <div class="wf0historycategory">
                    {{field.heading|translate|async}}</div>
                    @if (entity[field.name]!=undefined && entity[field.name]) {
                      <div class="_wf-historybolddata">{{entity |
                        mapvalue :
                      field | dateFormat}}</div>
                    }
                  </div>
                }
                @if (field.type == 'event' && checkExpression(field,entity)) {
                  <div [ngClass]="field.class_name ? field.class_name : '_wf-historytableft'"
                    >
                    <div class="_wf-historybolddata"><a
                      href="javascript:void(0)"
                    (click)="eventHandler(entity,field)">{{field.heading}}</a>
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
    <!-- <div class="row btn-margin  mt-3" *ngIf="utilService.isMobile()">
    <div class="col-12 text-center">
      <div *ngFor="let buttons of currentData['resouceDef'].config.action_buttons"
        class="mr-2">
        <button type="button" class="primary-btn mr-1 ml-1"
          (click)="onButtonClicked(buttons)"
          *ngIf="checkPermission(buttons)">
          <span>{{buttons.label | translate |
          async}}</span>
          <i class="fa fa-plus-square"
          aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div> -->
</div>
<!-- for form -->
@if (currentData.show && currentData.list.length > 0) {
  <div
    class="_arc-doc-viewer _wf-patienthistory box-shadow">
    @if (currentData['currentBtn']!=undefined && currentData['currentBtn']=='billing_journey') {
      <div class="_arc-top-right-section">
        <select (change)="setDropdownView($event);" class="form-control" [(ngModel)]="currentData.dropdownDataVal">
          @for (option of currentData.dropdownData; track option; let i = $index) {
            <option
            [value]="i">{{option.print_type}}</option>
          }
        </select>
      </div>
    }
    <!-- <div *ngIf="this.utilService.isMobile()"
    class="d-flex justify-content-end crossbutttoninhistory"><i
    aria-hidden="true" class="fa fa-times-circle"
  style="font-size: 1.5em;" (click)="closeButton()"></i></div> -->
  @if (currentData.selectedList) {
    <div class="h-100">
      <!-- <div class="col-4 _arc-select"
      *ngIf="currentData['currentBtn']!=undefined && currentData['currentBtn']=='billing_journey'">
      <select (change)="setDropdownView($event);" class="form-control"
        [(ngModel)]="currentData.dropdownDataVal">
        <option *ngFor="let option of currentData.dropdownData; let i = index;"
          [value]="i">
          {{option.print_type}}
        </option>
      </select>
    </div> -->
    @if (currentData.currentPrescription != undefined && currentData.type=='application/pdf') {
      <ng2-pdfjs-viewer
        pdfSrc="{{currentData.currentPrescription}}" [openFile]="false"
      [download]="true" [print]="true"></ng2-pdfjs-viewer>
    }
    @if (currentData.currentPrescription != undefined && currentData.type!='application/pdf') {
      <app-image-viewer
        style="width: 100%; height:600px"
        [src]="[currentData.currentPrescription]"
        [fileData]="currentData.imageInfo">
      </app-image-viewer>
    }
  </div>
}
</div>
}
</div>
</div>
<!-- <div class="row btn-margin mt-3" *ngIf="!utilService.isMobile()">
<div class="col-12 text-center"
  *ngIf="currentData['resouceDef']!=undefined && currentData['resouceDef'].config!=undefined && currentData['resouceDef'].config.action_buttons != undefined && this.currentData['selectedList'] != undefined && this.currentData['selectedList'] != {}">
  <div *ngFor="let buttons of currentData['resouceDef'].config.action_buttons"
    class="mr-2">
    <button type="button" class="primary-btn mr-1 ml-1"
      (click)="onButtonClicked(buttons)" *ngIf="checkPermission(buttons)">
      <span>{{buttons.label | translate | async}}</span>
      <i class="fa fa-plus-square" aria-hidden="true"></i>
    </button>
  </div>
</div>
</div> -->
</div>
}
</ng-container>


@if (currentData.list && currentData.list.length == 0) {
  <div class="_arc-nrf no-record-found">
    <div class="no-record-found-img-container">
      <img src="assets/images/nodata-icon.svg" class="no-records-found" />
      <div class="no-records-found-text">
        <span>{{'field.label.no_records_found' | translate | async}}</span>
      </div>
    </div>
  </div>
}